import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getItemMode", "getItemSubTitle", "getItemTitle", "getItemView", "getItemId", "position", "autoCloseTime", "offset", "items", "theme", "onCloseTrigered", "truncate", "onItemClose", "className", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useEffect, useState } from 'react';
import { Transition } from 'react-transition-group';
import { cnBem } from '@carnica/utils';
import { useManyRefs } from '@carnica/utils/hooks';
import { ThemedPortal } from "../../modules/ThemedPortal";
import styles from "./styles.pcss";
import { SnackBarItem } from "./SnackBarItem";
import { composePreparedProps, defaultSnackBarAnimationTime } from "./utils";
var cnSnackBar = cnBem('snackbar', styles);
var SnackBarRender = function SnackBarRender(props, ref) {
  var _objectSpread2;
  var _composePreparedProps = composePreparedProps(props),
    getItemMode = _composePreparedProps.getItemMode,
    getItemSubTitle = _composePreparedProps.getItemSubTitle,
    getItemTitle = _composePreparedProps.getItemTitle,
    getItemView = _composePreparedProps.getItemView,
    getItemId = _composePreparedProps.getItemId,
    _composePreparedProps2 = _composePreparedProps.position,
    position = _composePreparedProps2 === void 0 ? 'bottomCenter' : _composePreparedProps2,
    _composePreparedProps3 = _composePreparedProps.autoCloseTime,
    autoCloseTime = _composePreparedProps3 === void 0 ? 3500 : _composePreparedProps3,
    _composePreparedProps4 = _composePreparedProps.offset,
    offset = _composePreparedProps4 === void 0 ? 24 : _composePreparedProps4,
    _composePreparedProps5 = _composePreparedProps.items,
    items = _composePreparedProps5 === void 0 ? [] : _composePreparedProps5,
    theme = _composePreparedProps.theme,
    onCloseTrigered = _composePreparedProps.onCloseTrigered,
    _composePreparedProps6 = _composePreparedProps.truncate,
    truncate = _composePreparedProps6 === void 0 ? true : _composePreparedProps6,
    onItemClose = _composePreparedProps.onItemClose,
    className = _composePreparedProps.className,
    style = _composePreparedProps.style,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var refs = useManyRefs(items.length);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeItem = _useState2[0],
    setActiveItem = _useState2[1];
  useEffect(function () {
    if (items.length) {
      setActiveItem(items[0]);
    }
  }, [items]);
  var handleClose = function handleClose(item) {
    setActiveItem(items.find(function (el) {
      return getItemId(el) !== getItemId(item);
    }));
    onCloseTrigered === null || onCloseTrigered === void 0 ? void 0 : onCloseTrigered(item);
    // Необходимо чтоб отработала анимация, иначе игнорируется этап exit & exited
    setTimeout(function () {
      return onItemClose === null || onItemClose === void 0 ? void 0 : onItemClose(item);
    }, defaultSnackBarAnimationTime);
  };
  return /*#__PURE__*/React.createElement(ThemedPortal, _extends({
    className: cnSnackBar(null, [className]),
    ref: ref,
    style: _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, '--snackbar-zindex', (style === null || style === void 0 ? void 0 : style.zIndex) || 10), _defineProperty(_objectSpread2, '--snackbar-offset', typeof offset === 'number' ? "".concat(offset, "px") : offset), _objectSpread2), style),
    theme: theme
  }, otherProps, {
    "data-t-id": "components-SnackBar"
  }), items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Transition, {
      appear: true,
      in: activeItem ? getItemId(activeItem) === getItemId(item) : false,
      key: cnSnackBar('item', {
        index: getItemId(item)
      }),
      nodeRef: refs[index],
      timeout: defaultSnackBarAnimationTime,
      unmountOnExit: true
    }, function (animate) {
      return /*#__PURE__*/React.createElement(SnackBarItem, {
        autoCloseTime: autoCloseTime,
        className: cnSnackBar('item', {
          animate: animate,
          position: position,
          mode: getItemMode(item)
        }),
        mode: getItemMode(item),
        onClose: function onClose() {
          return handleClose(item);
        },
        ref: refs[index],
        subTitle: getItemSubTitle(item),
        title: getItemTitle(item),
        truncate: truncate,
        view: getItemView(item)
      });
    });
  }));
};
export var SnackBar = /*#__PURE__*/forwardRef(SnackBarRender);